import { render } from "./BubbleListComponent.vue?vue&type=template&id=a7436678&scoped=true&ts=true"
import script from "./BubbleListComponent.vue?vue&type=script&lang=ts"
export * from "./BubbleListComponent.vue?vue&type=script&lang=ts"

import "./BubbleListComponent.vue?vue&type=style&index=0&id=a7436678&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7436678"]])

export default __exports__